import * as React from 'react';
const SvgFacebook = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path fill="#fff" fillOpacity={0.01} d="M0 0h24v24H0z" />
    <path
      fill="currentColor"
      d="m15.698 12.398.489-2.957h-2.881V7.382c0-.845.326-1.478 1.63-1.478h1.414V3.21C15.589 3.106 14.72 3 13.958 3c-2.5 0-4.24 1.478-4.24 4.118v2.323H7v2.957h2.718V20h3.588v-7.602z"
    />
  </svg>
);
export default SvgFacebook;
